import { type ResultOf } from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation CoreMembersListPage_RemoveCoreMember($userId: ID!) {
    removeCoreMember(id: $userId) {
      result
    }
  }
`)

export const useRemoveCoreMemberMutation = (
  options: Omit<
    UseMutationOptions<ResultOf<typeof document>, unknown, string, unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()

  return useMutation({
    mutationFn: (userId) =>
      graphQLRequest({
        document,
        variables: { userId },
      }),
    ...options,
  })
}
